<template>
	<div class="not-found d-flex flex-column justify-content-center align-items-center">
		<h1>Такой страницы не существует.</h1>
		<router-link to="/" tag="a"> Вернем вас на Главную</router-link>
	</div>
</template>

<script>
	//const axios = require('axios');
	export default {
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	
	.not-found {
		width: 100vw;
		height: 80vh;
		h1{
			margin-bottom: 20px;
		}
		a {
			text-decoration: underline;
		}
	}

</style>